import { useSpellChecker, SpellCheckerServerError } from "./useSpellChecker";

export const useTeaserFormSpellChecker = () => {
  const spellChecker = useSpellChecker();

  const onSubmit = ({ submit, fields }) => {
    spellChecker
      .check([
        {
          name: "title",
          value: fields?.title
        },
        {
          name: "desc",
          value: fields?.desc
        }
      ])
      .then(({ isValid }) => {
        if (isValid) {
          submit();
        } else {
          spellChecker.skipSpellErrorsConfirm(submit);
        }
      })
      .catch(e => {
        if (e instanceof SpellCheckerServerError) {
          console.info("Spell checker is unreachable");
          submit();
        } else {
          throw e;
        }
      });
  };

  return {
    onSubmit,
    getFieldProps: spellChecker.getFieldProps
  };
};
